// extracted by mini-css-extract-plugin
export default {"wixChoiceText":"_gt0g8v"};